import React, { Suspense, lazy, useState, useEffect } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { Props } from './MediaSelector';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '../../utils/webpack/chunkRetry';

const MediaSelector = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "mediaPopup", webpackPrefetch: true */
        './MediaSelector'
      )
  )
);

export const LoadableMediaSelector: React.FC<Props> = props => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const waitForMount = typeof window === 'undefined' && !mounted;
  if (waitForMount) {
    return null;
  }

  return (
    <ErrorBoundary debugComponent="LoadableMediaSelector">
      <Suspense fallback={<LoadingIndicator view={'spinner'} coverMode />}>
        <MediaSelector {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
LoadableMediaSelector.displayName = 'LoadableMediaSelector';

export default LoadableMediaSelector;
